import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMinMax, selectFilteredProducts, getFilteredProducts } from './../store/products';
import { setOptionActive, setOptionValue, newUpdateOptionValue, newUpdateOptionActive } from './../store/filters';
import { setActiveFilterCategory } from './../store/app';
import { Range } from 'rc-slider';

// Category state
const range = {
    name: "range",
    buildOptions: function(products) {
        let minMax = getMinMax(products, this.dataPoint);
        this.addOption({name: "minMax", value: minMax, active: false, hasProducts: true});
        this.addOption({name: "filterBounds", value: minMax, active: false, hasProducts: true});
    },
    element: function() {return <RangeCategory category={this} />},
    productPassesFilter: function(product) {
        let filterBoundsOption = this.getOptionByName("filterBounds");
        if (!filterBoundsOption.active) return;
        if (isProductDataPointInRange(product[this.dataPoint], filterBoundsOption.value)) {
            return true;
        } else {
            return false;
        }
    },
    hasProductsTransform: function(products) {
        let minMax = getMinMax(products, this.dataPoint)
        this.options.forEach(op => {
            if (op.name === "minMax") op.value = minMax;
        })
        return this;
    },
    activeOptionsList: function() {
        let afList = [];
        let filterBoundsOption = this.getOptionByName("filterBounds");
        if (filterBoundsOption.active) afList.push(`${filterBoundsOption.value[0]} - ${filterBoundsOption.value[1]}`);
        return afList;
    },
    activeOptionsPills: function() {
        let aol = this.activeOptionsList();
        if (aol.length > 0) {
            return [this.displayName];
        } else {
            return [];
        }
    }
}

// React Element
const RangeCategory = ({category}) => {
    let filteredProducts = useSelector(selectFilteredProducts);
    let products = useSelector(state => state.products.products);
    let dispatch = useDispatch();
    let minMax = category.getOptionByName("minMax");
    let filterBoundsOption = category.getOptionByName("filterBounds");
    const [uiBounds, setUiBounds] = React.useState([0,0]);
    const [prevBounds, setPrevBounds] = React.useState([0,0]);
    
    React.useEffect(() => {
        if (!filterBoundsOption.active) {
            setUiBounds(minMax.value);
        }
    }, [filteredProducts])

    return (
        <React.Fragment>
            <Range
                pushable={category.meta.step ? category.meta.step : 1}
                step={category.meta.step ? category.meta.step : 1}
                min={minMax.value[0]} 
                max={minMax.value[1]} 
                value={uiBounds} 
                onChange={(e) => {
                    setUiBounds(e);
                }}
                onBeforeChange={(e) => {
                    setPrevBounds(e);
                }}
                onAfterChange={(e) => {
                    
                    // Check if range bounds are empty, if they are then revert to state before. Must mock the next state and run getFiltered products to check.
                    let catNextState = {
                        ...category,
                        options: newUpdateOptionValue(category, 'filterBounds', e).newOptions
                    }
                    catNextState = {
                        ...catNextState,
                        options: newUpdateOptionActive(catNextState, 'filterBounds', true).newOptions
                    }
                    
                    if(!getFilteredProducts(products, {[category.dataPoint]: catNextState}).length) {
                        setUiBounds(prevBounds);
                        //console.info("Hit empty range")
                        return;
                    }

                    let isActive = (minMax.value[0] !== e[0] || minMax.value[1] !== e[1]);
                    dispatch(setOptionValue(category.dataPoint, "filterBounds", e));
                    dispatch(setOptionActive(category.dataPoint, "filterBounds", isActive));
                    dispatch(setActiveFilterCategory(category.dataPoint));
                }}
            />
            <div className={"rangeFields"}>
                <input 
                    type={"text"} 
                    tabIndex={-1} 
                    className={"inlineInput rounded"} 
                    value={uiBounds[0] + (category.meta.units ? category.meta.units : "")} 
                    readOnly
                />
                <input 
                    type={"text"} 
                    tabIndex={-1} 
                    className={"inlineInput rounded"} 
                    value={uiBounds[1] + (category.meta.units ? category.meta.units : "")} 
                    readOnly
                />
            </div>
        </React.Fragment>
    )
}

// helpers

/**
 * Checks if a product data point is within a range. If the data point is an array, it will check if the first value 
 * is greater than the first value of the range and if the second value is less than the second value of the range, 
 * otherwise it will check if the single value of the product is between the range given (the classic scenario).
 * @param productDataPoint
 * @param range
 * @returns {boolean}
 */
function isProductDataPointInRange(productDataPoint, range) {
    if(Array.isArray(productDataPoint)) {
        return ((productDataPoint[0] >= range[0]) && (productDataPoint[1] <= range[1])); 
    }
    
    return ((productDataPoint >= range[0]) && (productDataPoint <= range[1]))
}

export default range;